import * as React from 'react';
import {Redirect} from 'react-router-dom';

export function NoCrmAccessRedirect() {
    return <Redirect to='/marketing/dashboard' />;
}
